<template>
  <!--
 SourceItemsCellElementLite, multi-root, лёгкий триггер.
    Поведение:
      Просто кликабельная ссылка "Элементы: N". При клике выгружаем данные через auxStore
      (как в SourceItemsCellElement.getSourceItems) и эмитим наружу sourceItemsRequested,
      чтобы родительский шелл показал диалог с результатами. Это:
, освобождает каждую ячейку от рендера q-dialog / q-spinner;
, позволяет обернуть отображение в один общий компонент-диалог в шелле;
, визуально 1:1, функционально, клик работает, диалог подключается снаружи.
 Если родитель не подключил handler, используем резервный вариант: console.log с данными.
  -->
  <span
    v-for="(link, i) in elementUrls"
    :key="i"
    class="qtl-source-link"
    role="link"
    tabindex="0"
    @click.stop="onLinkClick(link.ids, link.type)"
    @keydown.enter.stop="onLinkClick(link.ids, link.type)"
  >{{ link.name }}</span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { TableDataCellDisplayType } from "@/models/etc/types";
import type { CellDataIdList, TableDataCell } from "@/models/interfaces/entity-settings/querytable/querytable";
import { i18n } from "@/i18n";

const props = defineProps<{
  element: TableDataCell;
}>();

const emit = defineEmits<{
  (e: "sourceItemsRequested", payload: { ids: number[]; type: number }): void;
}>();

const t = (k: string) => i18n.global.t(k);

interface SourceLink { ids: number[]; name: string; type: number; }

const elementUrls = computed<SourceLink[]>(() => {
  const isSourceItem = props.element.DisplayType === TableDataCellDisplayType.IdList;
  if (!isSourceItem) return [];
  const res = (props.element.Data as CellDataIdList[]).map((cell) => ({
    ids: cell.IdList,
    type: cell.IdListEntityType,
    name: t("elements") + ": " + cell.IdList.length,
  }));
  // нет исходных элементов - пустая строка (прочерк оставляем только у параметров)
  return res.length ? res : [{ ids: [], name: "", type: 0 }];
});

function onLinkClick(ids: number[], type: number) {
  emit("sourceItemsRequested", { ids, type });
}
</script>

<style lang="scss" scoped>
.qtl-source-link {
  display: block;
  max-width: 100%;
  margin-right: 0;
  font-size: 13px;
  color: #438451;
  text-decoration: none;
  cursor: pointer;
  overflow-wrap: anywhere;
  word-break: normal;
  line-height: 1.2;
}

.qtl-source-link:hover,
.qtl-source-link:focus {
  text-decoration: underline;
  outline: none;
}
</style>
